import React from 'react'
import './footer.css';

const Footer = () => {
  return (
    <footer className='footer'>
           Copyright &#169; 2023 Ratan K Ojha. All rights reserved.
    </footer>
  );
}

export default Footer;